import React from "react"
import {
  LineChart,
  BarChart,
  Bar,
  Brush,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"

const ChartTwo = ({data}) => {
 
  //Length of data
  const leng = data.length

//Calculate max value in array, looping not an option

let maxOne = 0;

if (leng >=24) {
  maxOne = Math.max(data[leng-1].Price,data[leng-2].Price,data[leng-3].Price,data[leng-4].Price,
    data[leng-5].Price,data[leng-6].Price,data[leng-7].Price,data[leng-8].Price,data[leng-9].Price,
    data[leng-10].Price,data[leng-11].Price,data[leng-12].Price,data[leng-13].Price,
    data[leng-14].Price,data[leng-15].Price,data[leng-16].Price,data[leng-17].Price,
    data[leng-18].Price,data[leng-19].Price,data[leng-20].Price,data[leng-21].Price,
    data[leng-22].Price,data[leng-23].Price)
} else if (leng >=10) {
  maxOne = Math.max(data[leng-1].Price,data[leng-2].Price,data[leng-3].Price,data[leng-4].Price,
    data[leng-5].Price,data[leng-6].Price,data[leng-7].Price,data[leng-8].Price,data[leng-9].Price)
}

if (maxOne < data[leng-1].EandW) {
  maxOne = data[leng-1].EandW
}

//Round the max value  
  const maxOneRou = Math.ceil(maxOne/100000)*100000

//Create array for sales

let maxTwo = 0;

if (leng >=24) {
  maxTwo = Math.max(data[leng-1].Sales,data[leng-2].Sales,data[leng-3].Sales,data[leng-4].Sales,
    data[leng-5].Sales,data[leng-6].Sales,data[leng-7].Sales,data[leng-8].Sales,data[leng-9].Sales,
    data[leng-10].Sales,data[leng-11].Sales,data[leng-12].Sales,data[leng-13].Sales,
    data[leng-14].Sales,data[leng-15].Sales,data[leng-16].Sales,data[leng-17].Sales,
    data[leng-18].Sales,data[leng-19].Sales,data[leng-20].Sales,data[leng-21].Sales,
    data[leng-22].Sales,data[leng-23].Sales)
} else if (leng >=10) {
  maxTwo = Math.max(data[leng-1].Sales,data[leng-2].Sales,data[leng-3].Sales,data[leng-4].Sales,
    data[leng-5].Sales,data[leng-6].Sales,data[leng-7].Sales,data[leng-8].Sales,data[leng-9].Sales)
}

//Round the max value  
const maxTwoRou = Math.ceil(maxTwo/100)*100

//Create array for Detached Sales

let maxThr = 0;

if (leng >=24) {
  maxThr = Math.max(data[leng-1].Detached,data[leng-2].Detached,data[leng-3].Detached,data[leng-4].Detached,
    data[leng-5].Detached,data[leng-6].Detached,data[leng-7].Detached,data[leng-8].Detached,data[leng-9].Detached,
    data[leng-10].Detached,data[leng-11].Detached,data[leng-12].Detached,data[leng-13].Detached,
    data[leng-14].Detached,data[leng-15].Detached,data[leng-16].Detached,data[leng-17].Detached,
    data[leng-18].Detached,data[leng-19].Detached,data[leng-20].Detached,data[leng-21].Detached,
    data[leng-22].Detached,data[leng-23].Detached)
} else if (leng >=10) {
  maxThr = Math.max(data[leng-1].Detached,data[leng-2].Detached,data[leng-3].Detached,data[leng-4].Detached,
    data[leng-5].Detached,data[leng-6].Detached,data[leng-7].Detached,data[leng-8].Detached,data[leng-9].Detached)
}

//Round the max value  
const maxThrRou = Math.ceil(maxThr/100000)*100000

  return (
    <section>
      <div style={{margin:`0 auto 0 auto`}}>
        <h2>Average Prices</h2> 
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data} margin={{ top: 15, left: 20, right: 20 }} syncId="anyId">
          <Tooltip 
          formatter={time => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(time)}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="Price"
            stroke="blue"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="EandW"
            stroke="grey"
            name="England and Wales"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <XAxis
            dataKey="Year"
          />
          <YAxis
            interval={0}
            domain={[0, maxOneRou]}
            tickFormatter={time => new Intl.NumberFormat('en-GB').format(time)}
          />
          <CartesianGrid stroke="none" />
        </LineChart>
        </ResponsiveContainer>
        <h2>Property Sales</h2>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 15, left: 20, right: 20 }} syncId="anyId"> 
          <Tooltip 
          formatter={time => new Intl.NumberFormat('en-GB').format(time)}
          />
          <Legend />
          <Bar
            type="monotone"
            dataKey="Sales"
            stroke="green"
            fill="green"
            strokeWidth={1}
            isAnimationActive={false}
          />
          <XAxis
            dataKey="Year"
          />
          <YAxis
            interval={0}
            domain={[0, maxTwoRou]}
            tickFormatter={time => new Intl.NumberFormat('en-GB').format(time)}
          />
          <CartesianGrid stroke="none" />
          <Brush />
        </BarChart>
      </ResponsiveContainer>
        <h2>Average Prices by Property Type</h2>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data} margin={{ top: 15, left: 20, right: 20 }} syncId="anyId">
        <Tooltip 
          formatter={time => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(time)}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="Detached"
            stroke="Purple"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="SemiDetached"
            name="Semi Detached"
            stroke="DodgerBlue"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="Terraced"
            stroke="ForestGreen"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="Flat"
            stroke="OrangeRed"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <XAxis
            dataKey="Year"
          />
          <YAxis
            interval={0}
            domain={[0, maxThrRou]}
            tickFormatter={time => new Intl.NumberFormat('en-GB').format(time)}
          />
          <CartesianGrid stroke="none" />
        </LineChart>
      </ResponsiveContainer>
      </div>
         </section>
  )
}

export default ChartTwo
